import { Spin } from "antd";
import OrderViewSummaryFoodItem from "./OrderGridViewSummaryFoodItem";
import useUserStore from "../../../stores/store";
import { useEffect, useState } from "react";
import OrderFooterButtonsComponent from "./OrderFooterButtonsComponent";

export default function OrdersGridOrdersSummary({
  context,
  isPaidOrder,
  selectedFoods,
  orderedFoodItems,
  handleUpsertOrder,
  handleCancel,
  payAfterEat,
  handlePayAfterEat,
  priceSummary,
  updateFoodItem,
  upsertLoading,
  handleRemoveFoodItem,
  orderType,
  availableFoods,
}) {
  const { isPayLater, restaurantVat, restaurantServiceCharge, isVatIncluded, isServiceChargeIncluded, isSupplementaryDutyIncluded } = useUserStore();
  const [summaryDisplayArr, setSummaryDisplayArr] = useState([]);

  useEffect(() => {
    const tmpSummary = [{ key: 'subTotal', label: "Sub Total", value: priceSummary.subTotal.toFixed(2) }];
    
    if (isVatIncluded) {
      setSummaryDisplayArr(tmpSummary);
      return;
    }

    if (!isSupplementaryDutyIncluded && priceSummary.totalSd > 0) {
      tmpSummary.push({ key: 'supplementaryDuty', label: `Supplementary Duty`, value: priceSummary.totalSd.toFixed(2) });
    }

    if (!isServiceChargeIncluded && restaurantServiceCharge > 0) {
      tmpSummary.push({ key: 'serViceCharge', label: `Service charge (${restaurantServiceCharge.toFixed(2)}%)`, value: priceSummary.totalSC.toFixed(2) });
    }

    if (restaurantVat > 0) {
      tmpSummary.push({ key: 'VAT', label: `VAT (${restaurantVat.toFixed(2)}%)`, value: priceSummary.totalVat.toFixed(2) })
    }

    setSummaryDisplayArr(tmpSummary);
  }, [priceSummary, isVatIncluded, isServiceChargeIncluded, restaurantVat, restaurantServiceCharge, isSupplementaryDutyIncluded]);

  const onHandleButtonActions = ()=>{
    console.log('==> onHandleButtonActions called in ordersGridSummary <===');
  }
  
  return (
    <section className="w-full">
      <div className="w-full bg-white mt-4">
        {/* Summary Container */}
        <div className="w-full border border-[#E4E4E4]">
          {/* Header */}
          <div className="flex px-4 h-[50px] text-[14px] font-medium relative border-b border-[#E4E4E4]">
            <div className="w-full lg:w-[75%] pt-3">Order Summary</div>
            <div className="hidden lg:block w-[25%] pt-3 pl-2 relative">
              <span>Amount</span>
              <div className="w-[1px] h-[300px] bg-[#E4E4E4] absolute top-0 left-0" />
            </div>
          </div>

          {/* Selected Foods */}
          <div className="h-[250px] overflow-x-hidden overflow-y-auto">
            {selectedFoods.map((food, idx) => (
              <div key={food.fuid} className="relative">
                <OrderViewSummaryFoodItem
                  context={context}
                  food={food}
                  index={idx}
                  removeFood={handleRemoveFoodItem}
                  updateFoodItem={updateFoodItem}
                  orderedFoodItems={orderedFoodItems}
                  availableFoods={availableFoods}
                />
                {isPaidOrder && <div className="absolute inset-0 bg-transparent z-50 cursor-not-allowed" />}
              </div>
            ))}
          </div>
        </div>

        {/* Price Summary */}
        <div className="w-full bg-[#FFFBE4] pt-3 pb-2">
          {summaryDisplayArr.map((item) => (
            <div key={item.label} className="px-4 flex items-center justify-between">
              <h1 className="text-[13px] text-black">{item.label}</h1>
              <p className="text-[12px] text-[#354C7B] font-semibold">{item.value.toLocaleString()} TK</p>
            </div>
          ))}

          {/* Divider */}
          <div className="w-full h-[1px] bg-[#E4E4E4] my-3" />

          {/* Gross Total */}
          <div className="px-4 flex items-center justify-between text-[14px]">
            <h1 className="text-[#341557] font-semibold">Gross Total</h1>
            <p className="text-black font-semibold">{priceSummary.grossTotal.toFixed(2)} TK</p>
          </div>
        </div>

        {/* Buttons & Options */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-4 mt-6">
          {/* Pay After Eat */}
          <div className={`pl-4 ${orderType === "Dine-in" ? "visible" : "invisible"}`}>
            <label className="flex items-center">
              <input
                type="checkbox"
                disabled={context === 1 || !isPayLater}
                checked={payAfterEat}
                onChange={handlePayAfterEat}
                className="w-[18px] h-[18px] rounded-[5px] border-[2px] border-[#FA6060] ring-[#FA6060] accent-[#FA6060] outline-[#FA6060]"
              />
              <span className="ml-3 text-[14px] font-medium leading-[21px] text-[#FA6060]">Pay After Eat</span>
            </label>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-end gap-3 pr-4">
            <button
              disabled={upsertLoading}
              className="w-full sm:w-[154px] h-[42px] rounded-[5px] text-white bg-[#FA6060] text-[14px] font-bold"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="w-full sm:w-[154px] h-[42px] rounded-[5px] text-white bg-[#2EC114] text-[14px] font-bold"
              onClick={handleUpsertOrder}
            >
              {upsertLoading ? <Spin size="small" /> : context === 1 ? "Update Order" : "Add Order"}
            </button>
          </div>
        </div>
        {/* Table System Buttons */}
        <OrderFooterButtonsComponent context={null} onHanleButtonActions={onHandleButtonActions} orderStatus={``} params={{}}/>
      </div>
    </section>
  );
}
